import { render, staticRenderFns } from "./habeasData.vue?vue&type=template&id=1946f4a0&"
import script from "./habeasData.vue?vue&type=script&lang=js&"
export * from "./habeasData.vue?vue&type=script&lang=js&"
import style0 from "./habeasData.vue?vue&type=style&index=0&id=1946f4a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports